<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @new-item="newItem"
                            @delete-items="deleteItems"
                            @export="exportItems"
                            ref="gofixTable">
                            <template slot="gofix_table:started_date" slot-scope="row">
                                {{row.item.started_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                             <template slot="gofix_table:expiry_date" slot-scope="row">
                                {{row.item.expiry_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            title="Add Permit To Work" 
            hide-footer 
            :centered="true" 
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <gofix-form-dropdown 
                            label="PTW Type" 
                            vLabel="reference_value_text"
                            required
                            show-icon-required
                            :reduce="option => option.reference_value_text"
                            v-model="modals.add.data.type" 
                            :options="modals.add.options.ptw_types">
                        </gofix-form-dropdown>
                        <gofix-form-dropdown
                            vLabel="contract_reference_number"
                            label="Project" 
                            :filterable="false" 
                            :required="true"
                            :show-icon-required="true"
                            :options="modals.add.options.scontracts"
                            @search="searchContract"
                            v-model="modals.add.data.project" >
                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                <span>{{ option.contract_reference_number || '--' }}</span>
                            </template>
                            <template slot="gofixInput:dropdown:option" slot-scope="option">
                                <span>{{ option.contract_reference_number || '--' }}</span>
                            </template>
                        </gofix-form-dropdown>
                        <gofix-form-dropdown
                            label="Equipment Tag"
                            v-model="modals.add.data.equipment"
                            vLabel="tag_name"
                            :required="true"
                            :show-icon-required="true"
                            :options="modals.add.options.equipments"
                            @search="searchEquipment"
                            :clearable="false" 
                            :filterable="false">
                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                <template v-if="option.lift_name">
                                    {{ option.lift_name ? `Lift ${option.lift_name}` : '' }}{{ option.location_name ? ` - ${option.location_name}` : '' }}
                                </template>
                                <template v-else>
                                    {{ option.location_name ? `${option.location_name}` : '' }}
                                </template>
                            </template>
                            <template slot="gofixInput:dropdown:option" slot-scope="option">
                                <template v-if="option.lift_name">
                                    {{ option.lift_name ? `Lift ${option.lift_name}` : '' }}{{ option.location_name ? ` - ${option.location_name}` : '' }}
                                </template>
                                <template v-else>
                                    {{ option.location_name ? `${option.location_name}` : '' }}
                                </template>
                            </template>
                        </gofix-form-dropdown>
                        <gofix-form-input-textarea 
                            label="Description of Work" 
                            v-model="modals.add.data.description">
                        </gofix-form-input-textarea>

                        <b-row>
                            <b-col md="6">
                                <gofix-form-input-number 
                                    label="Number of Supervisor" 
                                    v-model="modals.add.data.number_of_supervisor" 
                                    :integer-limit="4" 
                                    :include-thousands-separator="false" 
                                    :rows="5"
                                    :allowDecimal="false" class="gofixInputNoMinWidth">
                                </gofix-form-input-number>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-input-number 
                                    label="Number of Workmen" 
                                    v-model="modals.add.data.number_of_workmen" 
                                    :integer-limit="4" 
                                    :include-thousands-separator="false" 
                                    :allowDecimal="false" class="gofixInputNoMinWidth">
                                </gofix-form-input-number>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <gofix-form-input-date
                                    :minDate="new Date()"
                                    required
                                    show-icon-required
                                    v-model="modals.add.data.started_date"
                                    label="Start Date">
                                </gofix-form-input-date>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-input-date
                                    :minDate="new Date()" 
                                    required
                                    show-icon-required
                                    v-model="modals.add.data.expiry_date"
                                    label="End Date">
                                </gofix-form-input-date>
                            </b-col>
                        </b-row>
                        <gofix-form-dropdown
                            label="Contractor Checklist"
                            vLabel="name_checklist_templates"
                            :clearable="false"
                            :required="true"
                            :show-icon-required="true"
                            :append-to-body="true"
                            :reduce="option => option.id"
                            v-model="modals.add.data.checklist_template_id"
                            :options="modals.add.options.checklist_templates">
                        </gofix-form-dropdown>
                        <gofix-form-dropdown
                            label="Assesor"
                            vLabel="name"
                            :filterable="false"
                            :append-to-body="true"
                            :options="modals.add.options.users"
                            @search="searchUsers"
                            v-model="modals.add.data.assesor">
                        </gofix-form-dropdown>
                        <gofix-form-dropdown
                            v-if="modals.add.data.type && modals.add.data.type == 'WAH'"
                            label="Assessor Checklist for Evaluation"
                            vLabel="name_checklist_templates"
                            :clearable="false"
                            :required="true"
                            :show-icon-required="true"
                            :append-to-body="true"
                            :reduce="option => option.id"
                            v-model="modals.add.data.assessor_checklist_for_evaluation_id"
                            :options="modals.add.options.assessor_checklists">
                        </gofix-form-dropdown>
                        <gofix-form-dropdown
                            label="Project Manager"
                            vLabel="name"
                            :filterable="false"
                            :append-to-body="true"
                            :options="modals.add.options.users"
                            @search="searchUsers"
                            v-model="modals.add.data.project_manager">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
import { filters } from '@/_filterVar.js'
import moment from 'moment';
export default {
    name: 'SafetyInspectionChecklist',
    data() {
        let filter = JSON.parse(JSON.stringify(filters['permit_to_work_listing']));
        return {
            tableConfig:{
                name: 'permit-to-work-listing',
                controls:{
                    create: this.$checkRole(this.$accessModule.permit_to_work, 'create'),
                    delete: this.$checkRole(this.$accessModule.permit_to_work, 'delete')
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "created_at",
                sortDirection: "desc",
                dataSelect: {
                    status: {
                        value: [
                            {value: 'New', text: 'New'},
                            {value: 'Submitted', text: 'Submitted'},
                            {value: 'Completed', text: 'Completed'},
                            {value: 'Approved ', text: 'Approved '},
                        ],
                        value_field: 'value',
                        text_field: 'text'
                    }
                },
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        project: null,
                        equipment: null,
                        checklist_template_id: null,
                        assessor_checklist_for_evaluation_id: null,
                        type: null,
                        description: null,
                        number_of_supervisor: null,
                        number_of_workmen: null,
                        started_date: null,
                        expiry_date: null,
                        project_manager: null,
                        assesor: null,
                    },
                    options: {
                        scontracts: [],
                        equipments: [],
                        users: [],
                        checklist_templates: [],
                        assessor_checklists: [],
                        ptw_types: []
                    }
                }
            },
            pagesEquipment: {
                isCMS: '1',
                limit: 100,
                page: 1,
                totalPage: 0,
                filter: JSON.parse(JSON.stringify(filters['equipment']))
            },
            timer: {
                equipment: null,
                scontracts: null,
                save: null
            },
        }
    },
    computed: {
        // Add computed properties here
    },
    watch: {
        "modals.add.data.type": function(val) {
            this.modals.add.options.assessor_checklists = [];
            this.modals.add.data.checklist_template_id = this.modals.add.data.assessor_checklist_for_evaluation_id = null;
            this.getChecklistTemplates();
            if(val && val == 'WAH') {
                this.getChecklistTemplates('PTW WAH Evaluation');
            }
        }
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("SafetyAppController/getPermitToWorkItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of users", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },  
        clickToRowItem(item) {
           this.$router.push(`/v2/permit-to-work/${item.id}`)
        },
        newItem() {
            if(!this.ClientContractID || !this.ClientContractID.id) {
                return this.$alertNotification("Please select a contract before create permit to work.", "warning");
            }
            this.getSContracts();
            this.getEquipments();
            // this.getChecklistTemplates();
            this.loadUser(100);
            this.getPTWType();
            this.modals.add.data = {
                project: null,
                equipment: null,
                checklist_template_id: null,
                assessor_checklist_for_evaluation_id: null,
                type: null,
                description: null,
                number_of_supervisor: null,
                number_of_workmen: null,
                started_date: null,
                expiry_date: null,
                project_manager: null,
                assesor: null,
            };
            this.modals.add.open = true;
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deletePermitToWorkItem", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'permit_to_work'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems() {
            // Handle exporting items
            // Implement export logic (e.g., to CSV, PDF, etc.)
        },

        async getSContracts() {
            if(!this.ClientContractID || !this.ClientContractID.id) {
                this.modals.add.options.scontracts = []
                return
            }
            let tableRequest = {
                filter: { client_contract_id: this.ClientContractID.id },
                page: 1,
                limit: -1
            }

            await this.$store.dispatch("SContractProjectController/getSContract", tableRequest)
                .then(response => {
                    this.modals.add.options.scontracts = response.items;
                })
                .catch(err => {})
        },
        async getEquipments(search = "") {
            if(this.ClientContractID && this.ClientContractID.id) {
                // this.loading.equipment = true;
                this.pagesEquipment.filter['equipment.is_active'] = {  type: 'boolean', value: true }
                this.pagesEquipment.filter.tag_name.value = search;
                this.pagesEquipment.filter.contract_id.value = this.ClientContractID.id;

                await this.$store.dispatch("EquipmentV2Controller/getEquipmentsOfLiftInspectionCalendar", this.pagesEquipment)
                .then(response => {
                    // this.loading.equipment = false;
                    this.modals.add.options.equipments = response.data.data.items;
                })
                .catch(err => {
                    // this.loading.equipment = false;
                    console.log(err)
                })
            }
        },
        async getChecklistTemplates(type = null){
            if(!this.modals.add.data.type) {
                this.modals.add.options.checklist_templates = [];
                return;
            }
            this.$store.dispatch( 'v2CheckListTemplateController/getListCheckListTemplate', {
                filter: {
                    contract_id: { type: 'number', value: this.ClientContractID.id, function:"=", with:[] },
                    type: { type: 'text', value: type ? type: `PTW ${this.modals.add.data.type}`, function:"=", with:[] }  
                },
                limit: -1,
                page: 1,
                isCMS: 1
            })
            .then(response => {
                if(type && type == 'PTW WAH Evaluation') {
                    this.modals.add.options.assessor_checklists = response.data.data.items;
                    if(this.modals.add.options.assessor_checklists.length) {
                        this.modals.add.data.assessor_checklist_for_evaluation_id = this.modals.add.options.assessor_checklists[0].id;
                    }
                    return;
                }

                this.modals.add.options.checklist_templates = response.data.data.items;
                if(this.modals.add.options.checklist_templates.length) {
                    this.modals.add.data.checklist_template_id = this.modals.add.options.checklist_templates[0].id;
                }
            })
            .catch(err => {
                this.modals.add.options.checklist_templates = [];
            });
        },
        async searchContract(search, loading) {
            loading(true)
            this.modals.add.options.scontracts = []
            if (this.timer.scontracts) {
                clearTimeout(this.timer.scontracts);
                this.timer.scontracts = null;
            }
            this.timer.scontracts = setTimeout(async () => {
                try {
                    await this.getSContracts(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        async searchEquipment(search, loading) {
            loading(true)
            this.modals.add.options.equipments = []
            if (this.timer.equipment) {
                clearTimeout(this.timer.equipment);
                this.timer.equipment = null;
            }
            this.timer.equipment = setTimeout(async () => {
                try {
                    await this.getEquipments(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        loadUser(limit_item, filters = {}) {
            filters.type_user = 'fm_user';
            this.$store
                .dispatch("v2UserController/searchListUser", {
                    limit: limit_item,
                    page: 1,
                    filters: filters,
                    useDatabaseView: true
                })
                .then((response) => {
                    this.modals.add.options.users = response.data;
                })
                .catch((err) => {});
        },
        searchUsers(search, loading) {
            loading(true);
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.loadUser(100, {
                    name: search
                });
                loading(false);
            }, 500);
        },
        getPTWType(){
            let filter = {reference_type: "Safety Type Permit To Work"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.modals.add.options.ptw_types = response.items;
                })
        },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {
                if(!this.modals.add.data.type) {
                    return this.$alertNotification("Please choose a ptw type.", "danger");
                }
                
                if(!this.modals.add.data.project) {
                    return this.$alertNotification("Please choose a project.", "danger");
                }

                if(!this.modals.add.data.equipment) {
                    return this.$alertNotification("Please choose a equipment.", "danger");
                }

                if(!this.modals.add.data.checklist_template_id) {
                    return this.$alertNotification("Please choose a checklist template.", "danger");
                }

                if(this.modals.add.data.type == 'WAH' && !this.modals.add.data.assessor_checklist_for_evaluation_id) {
                    return this.$alertNotification("Please choose a assessor checklist for evaluation", "danger");
                }

                if(!this.modals.add.data.started_date) {
                    return this.$alertNotification("Please choose a assessor start date", "danger");
                }

                if(!this.modals.add.data.expiry_date) {
                    return this.$alertNotification("Please choose a assessor end date", "danger");
                }

                if(moment(this.modals.add.data.started_date).isAfter(moment(this.modals.add.data.expiry_date))) {
                    flagDateCheck = true;
                    message = 'End Date must be greater than Start Date';
                }

                const daysDiff = moment(this.modals.add.data.expiry_date).diff(moment(this.modals.add.data.started_date), 'days');
                if(daysDiff > 6) {
                    return this.$alertNotification("Start Date and End Date cannot be more than 6 days apart", "danger");
                }

                if(this.modals.add.loading) return;
                this.modals.add.loading = true;

                let objeClone = {
                    client_contract_id: this.ClientContractID.id,
                    checklist_template_id: this.modals.add.data.checklist_template_id,
                    assessor_checklist_for_evaluation_id: this.modals.add.data.assessor_checklist_for_evaluation_id,
                    project_id: this.modals.add.data.project.id,
                    location_id: this.modals.add.data.equipment.location_id,
                    location: this.modals.add.data.equipment.location_name,
                    equipment_id: this.modals.add.data.equipment.id,
                    equipment_lift_number: this.modals.add.data.equipment.lift_name,
                    started_date: this.modals.add.data.started_date ? moment(this.modals.add.data.started_date).format('YYYY-MM-DD') : null,
                    expiry_date: this.modals.add.data.expiry_date ? moment(this.modals.add.data.expiry_date).format('YYYY-MM-DD') : null,
                    type: this.modals.add.data.type,
                    description: this.modals.add.data.description,
                    number_of_supervisor: this.modals.add.data.number_of_supervisor,
                    number_of_workmen: this.modals.add.data.number_of_workmen,
                    project_manager_id: this.modals.add.data.project_manager ? this.modals.add.data.project_manager.id : null,
                    assesor_id: this.modals.add.data.assesor ? this.modals.add.data.assesor.id : null,
                };
                
                this.$store.dispatch("SafetyAppController/createPermitToWorkItem", objeClone)
                .then(async response => {
                    this.modals.add.loading = false;
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.modals.add.open = false;
                    await this.$router.push(`/v2/permit-to-work/${response.id}`)
                    await this.$alertNotification(this.$notificationV2('adding', 'permit_to_work'), "success");
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })

            }, 200);
        }
    },
    created() {
        // Component lifecycle hook for initialization
    }
}
</script>

<style scoped>
.safety-inspection-checklist {
    padding: 20px;
}
</style>